<div class="site-section">
  <div class="container">
    <form [formGroup]="registerForm">
      <div class="row justify-content-center">
        <div class="col-md-5 mt-4 pt-4">
          <h2 class="formhead mt-4" *ngIf="!showverifyOtpForm">{{"TOPNAV.SIGN_UP" | translate}}</h2>
          <!--- Registration Form --->
          <div *ngIf="!showverifyOtpForm" class="formshadow">
            <div class="col-md-12 form-group">
              <label for="username">{{'SIGNUPPAGE.NAME' | translate}}</label>
              <input autocomplete="off" type="text" name="name" placeholder="{{'SIGNUPPAGE.NAME' | translate}}"
                class="form-control form-control-lg" formControlName="firstName" onkeypress="return /[a-z]/i.test(event.key)" />
              <div class="container-err" *ngIf="regsubmitted && f.firstName.errors">
                <div *ngIf="regsubmitted && f.firstName.errors.required" class="error-msg-lbl errormsg">
                  {{"SIGNUPPAGE.ERROR.FIRST_NAME_IS_REQUIRED" | translate}}
                </div>
              </div>
            </div>

            <div class="col-md-12 form-group">
              <label for="email">{{'SIGNUPPAGE.LASTNAME' | translate}}</label>
              <input autocomplete="off" type="text" name="name" placeholder="{{'SIGNUPPAGE.LASTNAME' | translate}}"
                class="form-control form-control-lg" formControlName="lastName"  onkeypress="return /[a-z]/i.test(event.key)" />
              <div class="container-err" *ngIf="regsubmitted && f.lastName.errors">
                <div *ngIf="regsubmitted && f.lastName.errors.required" class="error-msg-lbl errormsg">
                  {{"SIGNUPPAGE.ERROR.LAST_NAME_IS_REQUIRED" | translate}}
                </div>
              </div>
            </div>

            <div class="col-md-12 form-group">
              <label for="pword">{{'SIGNUPPAGE.MOBILE' | translate}}</label>
              <input autocomplete="off" type="text" name="name" placeholder="{{'SIGNUPPAGE.MOBILE' | translate}}"
                class="form-control form-control-lg" formControlName="userName" />
              <div class="container-err" *ngIf="regsubmitted && f.userName.errors">
                <div *ngIf="regsubmitted && f.userName.errors.required" class="error-msg-lbl errormsg">
                  {{"SIGNUPPAGE.ERROR.MOBILE_REQUIRED" | translate}}
                </div>
                <div *ngIf="regsubmitted && f.userName.errors.userNameValidation" class="error-msg-lbl errormsg">
                  {{"SIGNUPPAGE.ERROR.MOBILE_VALID_REQUIRED" | translate}}
              </div>
              </div>
            </div>

            <div class="col-md-12 form-group">
              <label for="pword2">{{'SIGNUPPAGE.PASSWORD' | translate}}</label>
              <input autocomplete="off"  [type]="hide ? 'password' : 'text'" type="text" name="name" placeholder="{{'SIGNUPPAGE.PASSWORD' | translate}}"
                class="form-control form-control-lg" formControlName="password" />
                <span class="btn-visible" id="logwith1237" name="logwith1237" *ngIf="!hide" (click)="showPassword()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 15">
                      <path fill="#5F6778" fill-rule="nonzero"
                          d="M11.996.046C7.412.046 3.256 2.554.188 6.628a.95.95 0 0 0 0 1.133c3.067 4.079 7.224 6.587 11.808 6.587s8.741-2.508 11.809-6.582a.95.95 0 0 0 0-1.134C20.737 2.554 16.58.046 11.996.046zm.33 12.186A5.05 5.05 0 0 1 6.96 6.868c.157-2.513 2.194-4.55 4.706-4.707a5.05 5.05 0 0 1 5.365 5.365c-.162 2.508-2.199 4.544-4.707 4.706zm-.153-2.326A2.713 2.713 0 0 1 9.287 7.02a2.729 2.729 0 0 1 2.538-2.537 2.713 2.713 0 0 1 2.885 2.886 2.729 2.729 0 0 1-2.537 2.537z" />
                  </svg>
              </span>
              <span class="btn-visible" id="logshowpass11" name="logshowpass11" *ngIf="hide" (click)="showPassword()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
                  <g fill="#5F6778" fill-rule="evenodd">
                      <path fill-rule="nonzero"
                          d="M11.996 3.046c-4.584 0-8.74 2.508-11.808 6.582a.95.95 0 0 0 0 1.133c3.067 4.079 7.224 6.587 11.808 6.587s8.741-2.508 11.809-6.582a.95.95 0 0 0 0-1.134c-3.068-4.078-7.225-6.586-11.809-6.586zm.33 12.186A5.05 5.05 0 0 1 6.96 9.868c.157-2.513 2.194-4.55 4.706-4.707a5.05 5.05 0 0 1 5.365 5.365c-.162 2.508-2.199 4.544-4.707 4.706zm-.153-2.326a2.713 2.713 0 0 1-2.886-2.886 2.729 2.729 0 0 1 2.538-2.537 2.713 2.713 0 0 1 2.885 2.886 2.729 2.729 0 0 1-2.537 2.537z" />
                      <path d="M20.132 0l1.414 1.414L3.868 19.092l-1.414-1.414z" />
                  </g>
              </svg>
              </span>
              <!-- <div class="container-err" *ngIf="regsubmitted && f.password.errors">
                <div *ngIf="regsubmitted && f.password.errors.required" class="error-msg-lbl errormsg">
                  {{"SIGNUPPAGE.ERROR.PASSWORD_IS_REQUIRED" | translate}}
                </div>
              </div> -->
              <div class="container-err" *ngIf="regsubmitted && f.password.errors">
                <div *ngIf="regsubmitted && f.password.errors.pattern" class="error-msg-lbl errormsg">
                   {{"SIGNUPPAGE.ERROR.PASSWORD_IS_REQUIRED_VALIDATION" | translate}}
                                 </div>
                <div *ngIf="regsubmitted && f.password.errors.required" class="error-msg-lbl errormsg">
                  {{"SIGNUPPAGE.ERROR.PASSWORD_IS_REQUIRED" | translate}}
                </div>
              </div>
            </div>

            <div class="text-center mt-4">
              <input type="submit" [value]="'TOPNAV.SIGN_UP' | translate" (click)="onRegisterFormSubmit()"
                class="btn btn-primary px-5">
            </div><br>

            <p class="text-center">{{"SIGNUPPAGE.ALREADY_HV_ACCOUNT" | translate}}<span routerLink="/login" class="notmember"> {{"TOPNAV.SIGN_IN" |
              translate}}</span> </p>
          </div>

          <!---- Verify OTP ---->
          <div *ngIf="showverifyOtpForm">
            <h2 class="formhead mt-4">{{"VERIFYOTP.VERIFY_OTP" |
              translate }}</h2>

            <form [formGroup]="OTPForm" class="formshadow text-center" style="height:145px;">
              <label for="pword2">{{"VERIFYOTP.ENTER_OTP" |
                translate}}</label><br>
              <input class="txt-otp" type="number" name="code" maxlength="1" id="input1"
                formControlName="input1" (keyup)="focusInput($event, '1')" (input)="restrictInput($event)" />
              <input class="txt-otp" type="number" name="code" maxlength="1" id="input2"
                formControlName="input2" (keyup)="focusInput($event, '2')" (input)="restrictInput($event)" />
              <input class="txt-otp" type="number" name="code" maxlength="1" id="input3"
                formControlName="input3" (keyup)="focusInput($event, '3')" (input)="restrictInput($event)" />
              <input class="txt-otp" type="number" name="code" maxlength="1" id="input4"
                formControlName="input4" (keyup)="focusInput($event, '4')"  (input)="restrictInput($event)"/><br>
                <a class="resendadj" (click)="onRegisterFormSubmit()">Resend OTP</a>
              <!-- <div class="text-center mt-4">
                <a (click)="onRegisterFormSubmit()" class="btn btn-primary px-5 mt-4" type="submit">{{"FORGOTPASS.SENDOTP" |
                  translate}}</a>
              </div> -->
            </form>
          </div>
          <br>
        </div>
      </div>
    </form>
  </div>
</div>